"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _contexts = require("../../../contexts");

var _Footer = _interopRequireDefault(require("../components/Footer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Footer(_ref) {
  var assetId = _ref.assetId,
      versionNumber = _ref.versionNumber,
      outputStatus = _ref.outputStatus,
      hasInternalPermission = _ref.hasInternalPermission,
      videoPermissions = _ref.videoPermissions,
      isVideoReady = _ref.isVideoReady,
      isLatestVersion = _ref.isLatestVersion,
      currentVersion = _ref.currentVersion,
      requestChanges = _ref.requestChanges,
      goBackToProjects = _ref.goBackToProjects;
  return /*#__PURE__*/_react.default.createElement(_contexts.VideoReviewContext.Consumer, null, function (_ref2) {
    var _ref2$state = _ref2.state,
        internalMode = _ref2$state.internalMode,
        hasUpdatePermission = _ref2$state.hasUpdatePermission,
        nextStatus = _ref2$state.nextStatus,
        _ref2$actions = _ref2.actions,
        onApproveVersion = _ref2$actions.onApproveVersion,
        onRequestChanges = _ref2$actions.onRequestChanges,
        onRequestChangesForApproved = _ref2$actions.onRequestChangesForApproved,
        toggleInternalMode = _ref2$actions.toggleInternalMode,
        onRequestApproval = _ref2$actions.onRequestApproval;
    return /*#__PURE__*/_react.default.createElement(_commonReact.AssetSelector, {
      assetId: assetId
    }, function (asset) {
      return /*#__PURE__*/_react.default.createElement(_commonReact.CommentsConsumer, null, function (_ref3) {
        var comments = _ref3.state.comments;
        return /*#__PURE__*/_react.default.createElement(_Footer.default, {
          asset: asset,
          status: outputStatus,
          versionNumber: versionNumber,
          onApproveVersion: onApproveVersion,
          onRequestChanges: onRequestChanges,
          onRequestChangesForApproved: onRequestChangesForApproved,
          onRequestApproval: onRequestApproval,
          internalMode: internalMode,
          toggleInternalMode: toggleInternalMode,
          hasInternalPermission: hasInternalPermission,
          hasUpdatePermission: hasUpdatePermission,
          videoPermissions: videoPermissions,
          isVideoReady: isVideoReady,
          comments: comments,
          isLatestVersion: isLatestVersion,
          currentVersion: currentVersion,
          nextStatus: nextStatus,
          requestChanges: requestChanges,
          goBackToProjects: goBackToProjects
        });
      });
    });
  });
}

var _default = Footer;
exports.default = _default;